import React from 'react';
import { Tabs } from 'antd';
import * as moment from 'moment';
import { MddCommon } from '@macrocura/utils';
import 'src/assets/less/pick-up-time.less';
import { IPickUpTimeSelect } from 'src/entity/SettingEntity';

const { TabPane } = Tabs;
interface ITime {
  name: string;
  // start / end 等于 0 时候为实时一小时内
  start: number;
  end: number;
}

interface IFrontTime extends ITime {
  index: number;
}

// 默认index
const defaultIndex = -99;
const startTime = 8;
const endTime = 20;
// 实时时间
const actualTime: ITime = {
  name: '一小时内',
  start: 0,
  end: 0,
};

// 时间选择列表
const timeList: ITime[] = [
  {
    name: '8:00~9:00',
    start: 8,
    end: 9,
  },
  {
    name: '9:00~10:00',
    start: 9,
    end: 10,
  },
  {
    name: '10:00~11:00',
    start: 10,
    end: 11,
  },
  {
    name: '11:00~12:00',
    start: 11,
    end: 12,
  },
  {
    name: '12:00~13:00',
    start: 12,
    end: 13,
  },
  {
    name: '13:00~14:00',
    start: 13,
    end: 14,
  },
  {
    name: '14:00~15:00',
    start: 14,
    end: 15,
  },
  {
    name: '15:00~16:00',
    start: 15,
    end: 16,
  },
  {
    name: '16:00~17:00',
    start: 16,
    end: 17,
  },
  {
    name: '17:00~18:00',
    start: 17,
    end: 18,
  },
  {
    name: '18:00~19:00',
    start: 18,
    end: 19,
  },
  {
    name: '19:00~20:00',
    start: 19,
    end: 20,
  },
  {
    name: '20:00~21:00',
    start: 20,
    end: 21,
  },
];

interface IDateList {
  name: string;
  date: string;
  list: IFrontTime[];
}

interface IPickUpTimeProps {
  /** 数据改变时回调 */
  onPick: (value: IPickUpTimeSelect | undefined) => void;
}

interface IPickUpTimeState {
  dateList: IDateList[];
  /** 选择时间下标 */
  indexInfo: {
    date: number;
    time: number;
  };
  /** 选中时间 */
  selectTime: string;
}

export default class PickUpTime extends React.Component<IPickUpTimeProps, IPickUpTimeState> {
  constructor(props: IPickUpTimeProps) {
    super(props);
    this.state = {
      selectTime: '',
      dateList: [],
      indexInfo: {
        time: defaultIndex,
        date: defaultIndex,
      },
    };
  }

  async componentDidMount(): Promise<void> {}

  async UNSAFE_componentWillMount() {
    this.initDateList();
  }

  /** 数据初始化 */
  private async initDateList() {
    // const toDay
    const date = moment(new Date());
    const today = date.format('YYYY-MM-DD');
    const start = Number(date.format('HH'));
    const tomorrow = date.add(1, 'days').format('YYYY-MM-DD');
    const afterTomorrow = date.add(1, 'days').format('YYYY-MM-DD');

    const list: IDateList[] = [];
    if (start < endTime && start >= startTime) {
      const index = timeList.findIndex((item) => item.start === start + 1);
      if (index > -1) {
        // 当前一个小时 如何计算；
        list.push({
          name: '今天',
          date: today,
          list: [actualTime, ...timeList.slice(index)].map((item) => {
            return {
              ...item,
              index: 0,
            };
          }),
        });
      }
    } else {
      list.push({
        name: '今天',
        date: today,
        list: [],
      });
    }

    list.push({
      name: '明天',
      date: tomorrow,
      list: timeList.map((item) => {
        return {
          ...item,
          index: 1,
        };
      }),
    });
    list.push({
      name: '后天',
      date: afterTomorrow,
      list: timeList.map((item) => {
        return {
          ...item,
          index: 2,
        };
      }),
    });

    let timeIndex = defaultIndex;
    if (list[0].list.length > 0) {
      timeIndex = 0;
    }

    this.setState({
      dateList: list,
      indexInfo: {
        date: 0,
        time: timeIndex,
      },
    });
    await MddCommon.sleep(0);
    this.dateProcess();
  }

  /** 时间段点击 */
  private async onClickDate(value: ITime, timeIndex: number, dateIndex: number) {
    this.setState({
      indexInfo: {
        date: dateIndex,
        time: timeIndex,
      },
    });
    await MddCommon.sleep(0);
    this.dateProcess();
  }

  /** 选中数据处理 */
  private dateProcess(): void {
    let selectTime = '';
    const { indexInfo, dateList } = this.state;
    if (indexInfo.time === defaultIndex) {
      // 回调返回undefined
      this.props.onPick(undefined);
    } else {
      const date = dateList[indexInfo.date];
      const time = date.list[indexInfo.time];
      selectTime = `${date.date} ${time.name}`;
      this.props.onPick({
        date: date.date || '',
        time: { start: time.start, end: time.end },
        isActual: !time.start,
      });
    }

    this.setState({
      selectTime,
    });
  }

  /** 渲染 */
  private getTabList = (): JSX.Element[] => {
    const result: JSX.Element[] = [];
    const { dateList, indexInfo } = this.state;
    const time = indexInfo.time;
    const date = indexInfo.date;
    dateList.forEach((item, index) => {
      result.push(
        <TabPane
          tab={
            <div className="pick-time-header">
              <p>{item.name}</p>
              <p>{item.date}</p>
            </div>
          }
          key={`${index}`}
        >
          <div className="pick-time-wrapper">
            <div className="pick-time-list">
              {item.list.map((f, i) => {
                return (
                  <span
                    onClick={() => this.onClickDate(f, i, index)}
                    key={`${i}`}
                    className={'pick-time-item ' + `${date === index && time === i ? 'active' : ''}`}
                  >
                    {f.name}
                  </span>
                );
              })}
            </div>
          </div>
        </TabPane>
      );
    });
    return result;
  };

  render() {
    const { selectTime } = this.state;
    return (
      <div>
        <div>期望上门时间：{selectTime || ''}</div>
        <Tabs defaultActiveKey="0" className="pick-time">
          {this.getTabList()}
        </Tabs>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Order/components/PickUpTime.tsx